import React, { CSSProperties } from 'react';

interface Base64ImgProps {
  data?: string | null;
  alt?: string;
  className?: string;
  style?: CSSProperties;
}

export default function Base64Img({ data, alt, className, style }: Base64ImgProps) {
  return (
    <img
      src={`data:image/*;base64,${data}`}
      alt={alt ? alt : 'Imagem'}
      className={className}
      style={style}
    />
  );
}
